export function calculateOffset(a: number, b: number, scale: number) {
  return (a - b) / scale;
}
